import { useMediaQuery } from 'react-responsive';

const useDesktopMediaQuery = () => {
    return useMediaQuery({
        query: '(min-width: 768px)',
    });
};

export default useDesktopMediaQuery;
